export default class UI_PointsCounter extends G.Text {
  /**
   * The counter text of how much points you have
   * @param {number} x
   * @param {number} y
   */
  constructor(x, y) {
    super(x, y, `${G.capitalize(OMT.language.getText('points'))}: 0`, G.OMTsettings.elements.UI_PointsCounter.text.style, 0.5, 500);

    this._points = 0;
    this._pointsTarget = 0;

    this._signalBinding = G.sb('onPointsChange').add((amount) => {
      this._pointsTarget = amount;
    });

    game.add.existing(this);
  }

  /**
   * Destroy!
   */
  destroy() {
    if (this._signalBinding) {
      if (this._signalBinding.detach) {
        this._signalBinding.detach();
      }
      this._signalBinding = null;
    }
    super.destroy();
  }

  /**
   * Update
   */
  update() {
    if (this._points === this._pointsTarget) return;
    this._points += (game.math.clamp(Math.ceil((this._pointsTarget - this._points) * 0.2), 0, this._pointsTarget - this._points));
    this.setText(`${G.capitalize(OMT.language.getText('points'))}: ${this._points.toString()}`);
  }
}
